// extracted by mini-css-extract-plugin
module.exports = {"price":"price--1gWVH","vertical":"vertical--2VoIB","value":"value--3klxu","description":"description--1dwLx","subtitle":"subtitle--BZ1WD","horizontal":"horizontal--1XUZ8"};